// Rótulos e cores do painel. Os códigos vêm do banco; aqui só ganham texto legível.

export const UNASSESSED_LABEL = "SEM_AVALIACAO";
export const UNASSESSED_COLOR = "#C9CED3";

const HEALTH: Record<string, { text: string; color: string }> = {
  BOM: { text: "Bom", color: "#1B6E4F" },
  REGULAR: { text: "Regular", color: "#F57C00" },
  RUIM: { text: "Ruim", color: "#D32F2F" },
  CRITICO: { text: "Crítico", color: "#8D1F1F" },
  MORTO: { text: "Morta", color: "#3F4A52" },
  SEM_CLASSE: { text: "Sem classe", color: UNASSESSED_COLOR },
};

const RISK: Record<string, { text: string; color: string }> = {
  BAIXO: { text: "Baixo", color: "#1B6E4F" },
  MEDIO: { text: "Médio", color: "#FBC02D" },
  ALTO: { text: "Alto", color: "#F57C00" },
  CRITICO: { text: "Crítico", color: "#D32F2F" },
  SEM_CLASSE: { text: "Sem classe", color: UNASSESSED_COLOR },
};

export function healthStyle(code: string) {
  return HEALTH[code] ?? { text: code, color: UNASSESSED_COLOR };
}

export function riskStyle(code: string) {
  return RISK[code] ?? { text: code, color: UNASSESSED_COLOR };
}

const WORKFLOW: Record<string, string> = {
  DRAFT: "Rascunho",
  IN_PROGRESS: "Em andamento",
  SUBMITTED: "Enviada",
  UNDER_REVIEW: "Em revisão",
  VALIDATED: "Validada",
  CONCLUDED: "Concluída",
  RETURNED: "Devolvida",
  CANCELLED: "Cancelada",
};

export function workflowText(code: string | null) {
  return code ? (WORKFLOW[code] ?? code) : "—";
}

export function workflowTone(code: string | null): "ok" | "wait" | "bad" | "idle" {
  if (code === "VALIDATED" || code === "CONCLUDED") return "ok";
  if (code === "SUBMITTED" || code === "UNDER_REVIEW") return "wait";
  if (code === "RETURNED" || code === "CANCELLED") return "bad";
  return "idle";
}

const INSPECTION_TYPE: Record<string, string> = {
  CADASTRAL: "Cadastral",
  RISCO: "Risco",
  INVENTORY_BASELINE: "Inventário",
  ARBORICULTURAL_TECHNICAL: "Técnica",
  MONITORING: "Monitoramento",
  EMERGENCY: "Emergência",
};

export function inspectionTypeText(code: string | null) {
  return code ? (INSPECTION_TYPE[code] ?? code) : "—";
}

const RECOMMENDATION: Record<string, string> = {
  SEM_INTERVENCAO: "Sem intervenção",
  MONITORAR: "Monitorar",
  PODA_LIMPEZA: "Poda de limpeza",
  PODA_CORRETIVA: "Poda corretiva",
  PODA_EMERGENCIAL: "Poda emergencial",
  TRATAMENTO_FITOSSANITARIO: "Tratamento fitossanitário",
  SUPRESSAO: "Supressão",
  TRANSPLANTE: "Transplante",
  REPLANTIO: "Replantio",
  VISTORIA_COMPLEMENTAR: "Vistoria complementar",
};

export function recommendationText(code: string | null) {
  return code ? (RECOMMENDATION[code] ?? code) : "Sem recomendação registrada";
}

const ORIGIN: Record<string, string> = {
  FLORAIQ_APP: "Aplicativo de campo",
  FLORAIQ_WEB: "Site",
  NAO_INFORMADO: "Origem não registrada",
};

export function originText(code: string) {
  return ORIGIN[code] ?? code;
}

export function formatDate(iso: string | null) {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return y && m && d ? `${d}/${m}/${y}` : iso;
}

const MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

export function monthLabel(yyyyMm: string) {
  const [y, m] = yyyyMm.split("-");
  return `${MONTHS[Number(m) - 1] ?? m}/${y.slice(2)}`;
}
